<template>
  <div class="project" :class="{'project-mobile' : isMobile == 'mobile'}">
    <div>
      <el-row :gutter="20" type="flex" style="flex-wrap:wrap">
        <el-col :span="screenWidth <= 540?12:8" v-for="item in list" :key="item.id">
          <div class="project-list" @click="toJump(item.title,item.id)">
            <div>
              <img :src="item.imgUrl" alt="" width="100%" class="founding-img-list-item" style="object-fit:cover;"  >
            </div>
            <div style="padding: 1rem 1rem;" v-if="isMobile == 'pc'">
              <h3 class="project-list-title">{{item.name}}</h3>
              <div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;line-height: 2;">{{ item.content }}</div>
              <div style="text-align: right;margin:1rem;cursor: pointer;">
                {{$t('ViewDetails')}} <i class="el-icon-right"></i>
              </div>
            </div>
            <!-- 移动端 -->
            <div style="padding: 1rem 1rem;" v-if="isMobile == 'mobile'">
              <h3 class="project-list-title">{{item.name}}</h3>
                <div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;line-height: 2;">{{ item.content }}</div>
                <div style="text-align: right;margin:1rem;cursor: pointer;">
                  {{$t('ViewDetails')}} <i class="el-icon-right"></i>
                </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { listSpecFund } from '@/api/index';
export default {
  computed: {
    ...mapState(['screenWidth']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  data() {
    return {
      list: []
    };
  },
  mounted() {
    this.listSpecFunds()
  },
  methods: {
    toJump(title,id) {
      this.$router.push({
        path: '/foundationProject/sectorList',
        query: {
          title: title,
          id: id,
        },
      });
    },
    async listSpecFunds(moduleId, page, size, title) {
      let res = await listSpecFund({
        "type": 1,
        "page": page || 1,
        "size": size || 9
      })
      if (res.data && res.data != null) {
        this.list = res.data.records
      }

    },
  },
};
</script>

<style lang="less" scoped>
.project {
  padding: 2rem 10%;
  padding-top: 0;
  background-color: #ffffff;
  width: 80%;
  .project-list {
    width: 100%;
    background-color: #f6f6f6;
    border-radius: 0.5rem;
    overflow: hidden;
    margin-top: 2rem;
  }
}
.project-mobile{
  padding: 2rem 18px !important;
  width:91%!important;

}
a {
  text-decoration: none;
  color: black;
}
.project-list-title{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>